import './AppOutlets/index';
import './AppOutlets/custom';
import './SdkInit';
import {getOutlet} from 'reconnect.js';
import * as AppActions from './AppActions/index';

const ActionOutlet = getOutlet('actions');

ActionOutlet.update({
  ...AppActions,
});

if (process.env.NODE_ENV === 'production') {
  console.log = function () {};
}

console.log('App initialized');
